import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  heading: {
    id: 'linkCreate.modal.heading',
    defaultMessage: 'Create new',
    description: 'Header for the create modal'
  }
});